/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import React from 'react';
import PropTypes from 'prop-types';

import Message from '../Message';
import Visible from '../Visible';
import messages from './messages';
import Options from './Options';
import './DropdownStyles.scss';

const getPlaceholder = (
  selectedOption,
  placeholder
) => selectedOption?.value ? (selectedOption.label || selectedOption.value) : (
  <>
    {placeholder && <Message message={placeholder} />}
  </>
);

const DropdownComponent = ({
  containerRef,
  label,
  placeholder,
  noOptionsMessage,
  onSelect,
  toggleOpen,
  options,
  selectedOption,
  isOpen,
  small,
  overlap = true,
  required,
  minWidth,
  error,
  id,
  hasSelectedValue,
}) => {
  let optionsWrapperClassNames =
    'c-dropdown__options-container c-dropdown__options-container-overrided';
  let dropdownClassName = 'c-dropdown dropdown-container';
  let dropdownLabelClassName = 'c-dropdown__container c-dropdown__container-overrided';

  if (small) {
    dropdownClassName = `app-dropdown-small ${dropdownClassName}`;
  }

  if (error) {
    dropdownLabelClassName = `${dropdownLabelClassName} dropdown-container-error`;
  }

  if (!overlap) {
    optionsWrapperClassNames = `${optionsWrapperClassNames} dropdown-no-overlap`;
  }

  if (isOpen) {
    optionsWrapperClassNames = `${optionsWrapperClassNames} c-dropdown--active`;
  }

  if (hasSelectedValue) {
    dropdownLabelClassName =
      `${dropdownLabelClassName} c-dropdown__container-overrided--has-selected-value`;
  }

  let style = {};

  if (minWidth) {
    style = { minWidth };
  }

  return (
    <div className={dropdownClassName} data-testid={`dropdownInput-${id}`}>
      <Visible when={!!label}>
        <Visible when={!!label}>
          <label className="c-input-label" required={required}>
            <Message message={label} />
          </label>
        </Visible>
      </Visible>
      <div
        aria-labelledby="dropdown-label"
        tabIndex="0"
        className={dropdownLabelClassName}
        onClick={toggleOpen}
        ref={containerRef}
        style={style}
      >
        {getPlaceholder(selectedOption, placeholder)}
      </div>
      <div className={optionsWrapperClassNames} data-testid={`option${id}`}>
        <Options
          {...{
            options,
            noOptionsMessage: noOptionsMessage || messages.noDropdownOptions,
            onSelect,
          }}
        />
      </div>
    </div>
  );
};

const messageShape = {
  id: PropTypes.string.isRequired,
  defaultMessage: PropTypes.string.isRequired,
};

const optionShape = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.number]),
};

DropdownComponent.propTypes = {
  containerRef: PropTypes.object.isRequired,
  label: PropTypes.shape(messageShape),
  placeholder: PropTypes.shape(messageShape),
  noOptionsMessage: PropTypes.shape(messageShape),
  onSelect: PropTypes.func.isRequired,
  toggleOpen: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape(optionShape)).isRequired,
  selectedOption: PropTypes.shape(optionShape),
  isOpen: PropTypes.bool,
  small: PropTypes.bool,
  required: PropTypes.bool,
  minWidth: PropTypes.string,
  overlap: PropTypes.bool,
  error: PropTypes.object,
  id: PropTypes.string,
  hasSelectedValue: PropTypes.bool,
};

export default DropdownComponent;
